import { render, staticRenderFns } from "./MenuProfil.vue?vue&type=template&id=d0b3cf24"
import script from "./MenuProfil.vue?vue&type=script&lang=js"
export * from "./MenuProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports